import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BatchListComponent } from './batch-list/batch-list.component';
import { BatchViewComponent } from './batch-view/batch-view.component';
import { CreateBatchComponent } from './create-batch/create-batch.component';
import { EditBatchComponent } from './edit-batch/edit-batch.component';
import { BatchAuditComponent } from './batch-audit/batch-audit.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
  {
    path:'',
    children:[
      {path:'',redirectTo:'batch-list',pathMatch:'full'},
      {
        path:'create-batch',component:CreateBatchComponent
      },
      {
        path:'batch-list',component:BatchListComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment','Training Moderator'] } 
      },
      {
        path:'edit-batch/:id',component:EditBatchComponent
      },
      {
        path:'batch-view/:id',component:BatchViewComponent
      },
      {
        path:'batch-audit',component:BatchAuditComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment','Training Moderator'] } 
      },
      {
        path:'edit-batch-audit/:id',component:EditBatchComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BatchesRoutingModule { }
